import PropTypes from 'prop-types';
import React from 'react';
import HeroCard from '../card/hero_card';
import BrandingBanner from '../common/branding_banner';
// import { propTypes as rowPropTypes } from './row';
import getUniqueKeyForCard from '../../utils/getUniqueKeyForCard';
import { ROW_TYPE_ONE_FEATURED_STORY } from '../../constants';
import classNames from 'classnames';


const HeroRow = (props, context) => {
  const { cards, dataAttributes, type, moduleType, moduleTitle,
    channelCampaignBrandingImage, channelSubtitle, page_id, isHomepageRefresh } = props;
  const { isPreviewPage } = context;
  const [card] = cards;

  return (
    <div className={classNames('hero-row', {
      'splash': type === ROW_TYPE_ONE_FEATURED_STORY
    })}
    >
      <div className="hero-row-top">
        <div className="row" {...dataAttributes}>
          {
            <HeroCard {...card}
              key={getUniqueKeyForCard(card, isPreviewPage)}
              rowType={type}
              moduleType={moduleType}
              moduleTitle={moduleTitle}
              pageId={page_id}
              isHomepageRefresh={isHomepageRefresh}
            />
          }
        </div>
        {channelCampaignBrandingImage &&
          <BrandingBanner
            type="campaign"
            src={channelCampaignBrandingImage}
          />
        }
      </div>
      {channelSubtitle &&
        <div className="subtitle">
          <h2 dangerouslySetInnerHTML={{ __html: channelSubtitle }} />
        </div>
      }
    </div>
  );
};

// HeroRow.propTypes = Object.assign({ ...rowPropTypes }, {
//   dataAttributes: PropTypes.object.isRequired
// });

HeroRow.contextTypes = {
  isPreviewPage: PropTypes.bool.isRequired
};

export default HeroRow;
